const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  icon: state => state.user.icon,
  email: state => state.user.email,
  name: state => state.user.name,
  roles: state => state.user.roles,
  userId: state => state.user.userId,
  imUser: state => state.im.imUser,
  shopList: state => state.user.shopList,
  roleTypeList: state => state.user.roleTypeList,
  addRouters: state => state.permission.addRouters,
  routers: state => state.permission.routers,
  pageCacheVersion: state => routeName => {
    const routeVersion = state.pageCache.routeVersions[routeName] || 0
    return `${state.pageCache.version}-${routeVersion}`
  },
  breadcrumbParent: state => state.pageCache.breadcrumbParent
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js